var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 18L31.5 4.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5461 8.45395C25.1547 6.06728 21.9546 4.66511 18.5789 4.52482C15.2033 4.38454 11.8979 5.51637 9.31672 7.6964C6.73556 9.87642 5.06665 12.9458 4.64015 16.2974C4.21366 19.649 5.06065 23.0385 7.01356 25.7955C8.96648 28.5525 11.883 30.4761 15.1863 31.1857C18.4895 31.8954 21.9388 31.3393 24.8517 29.6277C27.7646 27.916 29.9289 25.1733 30.9166 21.9423C31.9042 18.7113 31.6431 15.2273 30.1851 12.1795",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7731 13.2269C21.6571 12.111 20.1854 11.4214 18.6138 11.2779C17.0422 11.1345 15.47 11.5463 14.1705 12.4418C12.8709 13.3372 11.9263 14.6597 11.5006 16.1794C11.075 17.699 11.1953 19.3198 11.8406 20.76C12.486 22.2002 13.6155 23.3687 15.033 24.0625C16.4505 24.7563 18.0663 24.9314 19.5995 24.5575C21.1327 24.1836 22.4865 23.2843 23.4255 22.0159C24.3644 20.7474 24.8293 19.1901 24.7392 17.6145",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.7f739e21cabe2b45a24a53776784bee5.svg";
export { ForwardRef as ReactComponent };